<template>
  <div class="main_container">
  	<van-nav-bar
      v-if="userInfo.Role == 'admin'"
		  title="通讯录"
		  left-text="返回"
      :right-text="rightText"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :fixed="true"
		/>
    <van-nav-bar
      v-if="userInfo.Role !== 'admin'"
      title="通讯录"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
    <div class="body">
      <div style="font-size: 31px;height: 55px;line-height: 55px;padding-left: 17px;">{{people_info.username}}</div>
      <van-cell-group>
        <van-cell title="昵称" :value="people_info.alianame"/>
        <van-cell v-show="!editMode" title="用户组" :value="people_info.contact_group_name"/>
        <van-cell v-show="editMode" title="用户组" :value="people_info.contact_group_name" is-link @click="showAllGroup=true"/>
        <van-cell title="电话" :value="people_info.phone" @click="telPhone(people_info.phone)"/>

        <!-- <van-cell v-show="!editMode" title="用户功能" :value="fullfuncText"/>
        <van-switch-cell v-show="editMode" title="用户功能" v-model="fullfuncVal" @change="changeUserFullfunc"/> -->

        <van-cell v-if="userInfo.Role == 'admin'">
          <template slot="title">
            <span class="van-cell-text">用户功能 </span>

            <el-switch
              v-show="editMode"
              v-model="people_info.fullfunc"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              @change="changeUserFullfunc"
              style="float: right;">
            </el-switch>
            <span v-show="people_info.fullfunc == 1" style="float: right;margin-right: 10px">全功能</span>
            <span v-show="people_info.fullfunc == 0" style="float: right;margin-right: 10px">限制功能</span>
          </template>
        </van-cell>
      </van-cell-group>
      <van-popup v-model="showAllGroup" position="bottom" :overlay="true">
        <van-picker show-toolbar
          title="改变组"
          :columns="userGroups"
          value-key="group_name"
          @cancel="showAllGroup=false"
          @confirm="onConfirm" />
      </van-popup>
    </div>
  </div>
</template>

<script>
var _ = require('lodash');
import { mapState } from 'vuex'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      people_info:'',
      showAllGroup:false,
      editMode:false,
      fullfuncVal:false
    }
  },
  mounted(){
    this.editMode = false
  	this.getUserInfo()
  },
  watch:{
  	userList(){
  		this.getUserInfo()
  	},
  	'$route'(to,from){
  		if (to.name == 'peopleDetail'){
  			this.getUserInfo()
  		}
  	},
  	userGroups(){
  		this.getUserInfo()
  	}
  },
  computed:{
  	scHeight:function(){
      return ''+document.documentElement.clientHeight - 138
    },
    ...mapState(['userInfo', 'userGroups','userList']),
    fullfuncText(){
      if (this.people_info.fullfunc == 1){
        return '无限制'
      }else{
        return '限制'
      }
    },
    // fullfuncVal(){
    //   if (this.people_info.fullfunc == 1){
    //     return true
    //   }else{
    //     return false
    //   }
    // },
    rightText(){
      if (this.editMode){
        return '完成'
      }else{
        return '编辑'
      }
    }
  },
  methods:{
  	onClickRight(){
      this.editMode=!this.editMode
  	},
  	onClickLeft(){
      this.$router.go(-1)
    },
  	getUserInfo(){
  		for(var i in this.userList){
  			if (this.userList[i].user_id == this.$route.params.people_id){
  				this.people_info = this.userList[i]
          if (this.people_info.fullfunc == 1){
            this.fullfuncVal = true
          }else{
            this.fullfuncVal = false
          }

  			}
  		}
  	},
  	onConfirm(value, index) {
  		var self = this
      this.axios_base.get('session/groupAddUser?user_str='+this.$route.params.people_id+'&group_id='+value.contact_group_id).then(function(resp){
        self.$store.dispatch('getUserByGroups')
        self.$store.dispatch('getUserList')
        self.showAllGroup = false
      })
    },
    changeUserFullfunc(v){
      if (!this.editMode){
        return
      }
      console.log(v)
      var d = JSON.stringify({fullfunc:this.people_info.fullfunc})
      this.axios_base.get('session/alterUser?user_id='+this.$route.params.people_id+'&data='+d).then(function(resp){
        self.$store.dispatch('getUserByGroups')
        self.$store.dispatch('getUserList')
      })
    },
    onCancel() {
      Toast('取消');
    },
    telPhone(n){
      window.location.href='tel:'+n
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.block_title{
  margin: 0;
  font-weight: 400;
  font-size: 13px;
  color: rgba(69,90,100,.6);
  padding: 6px 15px 3px;
  background: #e4e4e4;
}
</style>



// WEBPACK FOOTER //
// src/pages/people/peopleDetail.vue